/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CorrectActivityItemRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'
import {CorrectActivityItemResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'


export const correctActivityItem = (request: CorrectActivityItemRequest, options?: CashRequestOptions) => post<CorrectActivityItemRequest, CorrectActivityItemResponse>("/2.0/cash/correct-activity-item", request, {...options, rejectOnError: true })